"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    socDate: {},
    phoneNumberWithCountryCode: {
        countryCode: "+1",
    },
};
